<script>
    import NavigationHeader from '../NavigationHeader.vue';
    import ButtonIconLeft from '../buttons/ButtonIconLeft.vue';
    import ButtonNormal from '../buttons/ButtonNormal.vue';
    import UserService from '@/services/UserService';
    import PhonenumberService from '@/services/PhonenumberService';
    import SupportUserService from '@/services/SupportUserService';
    import { NORMAL_USER_PERMISSIONS, SERVICE_ID } from '@/services/Constants';
    import Modal from '../shared/Modal.vue';
    import NumberPicker from '../shared/NumberPicker.vue';
    import AccountService from '@/services/AccountService';
    import {email, required} from 'vuelidate/lib/validators';
    import { mapGetters } from 'vuex';
    import RandomPasswordGenerator from '@/services/RandomPasswordGenerator';

    export default {
        name: 'Fax',
        components: {
            NavigationHeader,
            ButtonIconLeft,
            ButtonNormal,
            Modal,
            NumberPicker,
        },
        data() {
            return {
                id: null,
                faxExisting: false,
                faxActivated: false,
                isModalForDeleteVisible: false,
                isModalForUpdateVisible: false,
                isSubmitted: false,
                allUsers: [],
                allExternalPhonenumbers: [],
                pickedPhonenumber: null,
                allInternalPhonenumbers: [],
                internalPhonenumberId: null,
                data: {
                    firstName: 'Fax',
                    familyName: 'FaxUser',
                    email: '',
                    login: '',
                    password: RandomPasswordGenerator._randomPassword(8, false),
                    language: 'default',
                    missedCallReport: true,
                    faxCoverPage: false,
                    faxEmailJournal: false,
                    faxCallerId: '',
                    faxHeader: '',
                },
                dataPhonenumbers: [],
                dataOld: {},
                faxNumberOld: null,
                saveButtonTitle: 'Speichern',
                confirmationButtonText: 'Fax aktivieren',
                updatedFaxConfigForOtherUsers: false,
                isModalForIbanCheckVisible: false,
                isIbanSet: false,
                accountInfo: null,
                isSubmittedPopup: false,
                iban: ''
            };
        },
        created() {
            this.init();
        },
        validations: {
            data: {
                email: {
                    required,
                    email,
                },
            },
            iban: {
                required,
            }
        },
        computed: {
            ...mapGetters({
                isTest: 'isTest',
            }),
            faxDataChanged() {
                if (this.faxActivated && this.dataOld !== {} && this.faxNumberOld !== null) {
                    if (this.data.email === this.dataOld.email && this.pickedPhonenumber.id === this.faxNumberOld.id) {
                        return false;
                    } else {
                        return true;
                    }
                } else {
                    return true;
                }
            },
        },
        methods: {
            init() {
                UserService.getAllUsers().then(responseGetAllUsers => {
                    this.allUsers = responseGetAllUsers.data;
                    SupportUserService._removeSupportUserFromList(this.allUsers);
                    PhonenumberService.getAllPhonenumbers().then(
                        responsePhonenumbers => {
                            this.checkIfFaxAlreadyExists();
                            this.getAndSortAllAvailablePhonenumbers(
                                responsePhonenumbers.data,
                            );
                            this.setDefaultPhonenumber();
                            if (!this.faxExisting) {
                                AccountService.getAccount().then(response => {
                                    if (response.status === 200) {
                                        this.data.faxHeader = response.data.company;
                                        this.accountInfo = response.data;
                                        this.checkIfIbanIsSet();
                                    }
                                });
                            }
                            this.dataOld = Object.assign({}, this.data);
                        },
                    );
                });
            },
            getAccount() {
                AccountService.getAccount().then(responseAccount => {
                    if (responseAccount.data != null) {
                        this.accountInfo = responseAccount.data;
                        this.checkIfIbanIsSet();
                    }
                });
            },
            resetData() {
                this.id = null;
                this.isSubmitted = false;
                this.allUsers = [];
                this.allExternalPhonenumbers = [];
                this.pickedPhonenumber = null;
                this.allInternalPhonenumbers = [];
                this.internalPhonenumberId = null;
                this.data = {
                    firstName: 'Fax',
                    familyName: 'FaxUser',
                    email: '',
                    login: '',
                    password: RandomPasswordGenerator._randomPassword(8, false),
                    language: 'default',
                    missedCallReport: true,
                    faxCoverPage: false,
                    faxEmailJournal: false,
                    faxCallerId: '',
                    faxHeader: '',
                };
                this.dataPhonenumbers = [];
                this.dataOld = {};
                this.faxNumberOld = null;
                this.saveButtonTitle = 'Speichern';
                this.confirmationButtonText = 'Speichern';
            },
            checkIfIbanIsSet() {
                if (this.accountInfo.iban !== '') {
                    this.isIbanSet = true;
                }
            },
            setDefaultPhonenumber() {
                for (const entry of this.allExternalPhonenumbers) {
                    if (this.faxExisting) {
                        if (entry.assignedUserAccountId === this.id) {
                            this.pickedPhonenumber = entry;
                            this.faxNumberOld = entry;
                            entry.available = true;
                            break;
                        }
                    } else {
                        if (this.pickedPhonenumber === null && entry.available) {
                            this.pickedPhonenumber = entry;
                            break;
                        }
                    }
                }
                if (this.faxExisting) {
                    for (const entry of this.allInternalPhonenumbers) {
                        if (entry.assignedUserAccountId === this.id) {
                            this.internalPhonenumberId = entry.id;
                            break;
                        }
                    }
                }
                if (this.pickedPhonenumber === null) {
                    this.pickedPhonenumber = {
                        phoneNumberComplete: '',
                        phoneNumberForLogin: '',
                        phonenumber: 'Keine Nummer zugewiesen',
                        phonenumberExtension: '',
                        phonenumberForForm: '',
                        assignedGroupAccountId: null,
                        assignedUserAccountId: null,
                        assignedServiceId: null,
                        available: false,
                        id: null
                    };
                    this.faxNumberOld = this.pickedPhonenumber;
                }
            },
            setPhonenumbersForFax() {
                for (const phonenumber of this.allExternalPhonenumbers) {
                    if (phonenumber.id === this.pickedPhonenumber.id) {
                        this.dataPhonenumbers.push({
                            accountId: this.id,
                            phoneNumberId: phonenumber.id,
                            serviceId: SERVICE_ID.Fax2Mail,
                        });
                        break;
                    }
                }
                if (!this.faxExisting) {
                    this.dataPhonenumbers.push({
                        accountId: this.id,
                        phoneNumberId: this.internalPhonenumberId,
                        serviceId: SERVICE_ID.StandardCallUser,
                    });
                }
            },
            checkIfFaxAlreadyExists() {
                for (const user of this.allUsers) {
                    if (user.firstName === 'Fax' && user.familyName === 'FaxUser') {
                        this.faxExisting = true;
                        this.faxActivated = true;
                        this.id = user.id;
                        this.data.firstName = user.firstName;
                        this.data.familyName = user.familyName;
                        this.data.email = user.email;
                        this.data.login = user.login;
                        this.data.faxCallerId = user.faxCallerId;
                        this.data.faxHeader = user.faxHeader;
                        this.saveButtonTitle = 'Änderungen speichern';
                        break;
                    }
                }
            },
            checkIfFaxInfoChanged() {
                if (
                    this.data.email === this.dataOld.email &&
                    this.data.faxCallerId === this.dataOld.faxCallerId &&
                    this.data.faxHeader === this.dataOld.faxHeader
                ) {
                    return false;
                } else {
                    return true;
                }
            },
            closeModalForDelete() {
                this.isModalForDeleteVisible = false;
            },
            confirmModalForDelete() {
                this.isModalForDeleteVisible = false;
                UserService.deleteUser(this.id)
                    .then(() => {
                        this.$toasted.global.starface_success({
                            message: 'Das Fax wurde deaktiviert.',
                            icon: 'FAX',
                        });
                        this.faxActivated = false;
                        this.faxExisting = false;
                        this.resetData();
                        this.init();
                    })
                    .catch(error => {
                        this.$toasted.global.starface_error({
                            message: 'Fax konnte nicht deaktiviert werden',
                            icon: 'FAX',
                        });
                    });
            },
            closeModalForUpdate() {
                this.isModalForUpdateVisible = false;
            },
            manageFaxStatus() {
                this.isModalForUpdateVisible = false;
                this.data.faxCallerId = this.pickedPhonenumber.phonenumber;
                this.data.login = this.pickedPhonenumber.phoneNumberForLogin;
                if (!this.faxExisting) {
                    this.activateFax();
                } else {
                    this.updateFax();
                }
            },
            transformDataForPutRequest() {
                const dataForPutRequest = {
                    firstName: this.data.firstName,
                    familyName: this.data.familyName,
                    email: this.data.email,
                    login: this.data.login,
                    faxCallerId: this.data.faxCallerId,
                    faxHeader: this.data.faxHeader,
                    language: 'default',
                };
                this.data = dataForPutRequest;
            },
            selectedPhonenumber() {
                for (const entry of this.allExternalPhonenumbers) {
                    if (entry.checked) {
                        return entry.phoneNumberCompleteAndFancy;
                    }
                }
            },
            findIdOfNewUserByLogin(userList) {
                for (const user of userList) {
                    if (user.login === this.data.login) {
                        this.id = user.id;
                    }
                }
            },
            setPhonenumbersForFaxUser() {
                for (const phonenumber of this.allExternalPhonenumbers) {
                    if (phonenumber.id === this.pickedPhonenumber.id) {
                        this.dataPhonenumbers.push({
                            accountId: this.id,
                            phoneNumberId: phonenumber.id,
                            serviceId: SERVICE_ID.Fax2Mail,
                        });
                    }
                }
                if (!this.faxExisting) {
                    this.dataPhonenumbers.push({
                        accountId: this.id,
                        phoneNumberId: this.internalPhonenumberId,
                        serviceId: SERVICE_ID.StandardCallUser,
                    });
                }
            },
            getAndSortAllAvailablePhonenumbers(responsePhonenumbers) {
                const {
                    external,
                    internal,
                    internalPhoneNumberId,
                } = PhonenumberService.splitAndSortNumbers(
                    responsePhonenumbers,
                    this.internalPhonenumberId,
                );
                this.allExternalPhonenumbers = external;
                this.allInternalPhonenumbers = internal;
                if (!this.faxExisting) {
                    this.internalPhonenumberId = internalPhoneNumberId;
                }
            },
            activateFax() {
                this.updateFaxHeaderIdAndFaxCallerIdForAllOtherUsers();
                UserService.createUser(this.data)
                    .then(responseCreateUser => {
                        UserService.getAllUsers().then(responseGetAllUsers => {
                            this.findIdOfNewUserByLogin(responseGetAllUsers.data);
                            this.setPhonenumbersForFaxUser();
                            UserService.assignPhonenumbersForUser(
                                this.id,
                                this.dataPhonenumbers,
                            ).then(response => {
                                UserService.revokeUserLogin(this.id, NORMAL_USER_PERMISSIONS);
                            }).then(responsePostNumbers => {
                                    this.$toasted.global.starface_success({
                                        message: 'Das Fax wurde aktiviert.',
                                        icon: 'FAX',
                                    });
                                    this.resetData();
                                    this.init();
                                })
                                .catch(error => {
                                    this.$toasted.global.starface_error({
                                        message: 'Fax konnte nicht aktiviert werden',
                                        icon: 'FAX',
                                    });
                                });
                        });
                    })
                    .catch(error => {
                        this.$toasted.global.starface_error({
                            message: 'Fax konnte nicht aktiviert werden',
                            icon: 'FAX',
                        });
                    });
            },
            updateFax() {
                if (this.checkIfFaxInfoChanged()) {
                    this.transformDataForPutRequest();
                    this.updateFaxHeaderIdAndFaxCallerIdForAllOtherUsers();
                    this.updatedFaxConfigForOtherUsers = true;
                    UserService.updateUser(this.id, this.data)
                    .then(responseUpdate => {
                        if (
                            this.pickedPhonenumber.id === this.faxNumberOld.id
                        ) {
                            this.$toasted.global.starface_success({
                                message: 'Änderungen gespeichert',
                                icon: 'FAX',
                            });
                        }
                        this.dataOld = Object.assign({}, this.data);
                    })
                    .catch(error => {
                        this.$toasted.global.starface_error({
                            message: 'Fax konnte nicht geändert werden',
                            icon: 'FAX',
                        });
                    });
                }
                if (this.pickedPhonenumber.id !== this.faxNumberOld.id) {
                    this.setPhonenumbersForFax();
                    if (!this.updatedFaxConfigForOtherUsers) {
                        this.updateFaxHeaderIdAndFaxCallerIdForAllOtherUsers();
                    }
                    UserService.deleteUsersPhonenumber(
                        this.id,
                        this.faxNumberOld.id,
                    )
                    .then(responseDelete => {
                        UserService.assignPhonenumbersForUser(
                            this.id,
                            this.dataPhonenumbers,
                        )
                        .then(responsePut => {
                            this.$toasted.global.starface_success({
                                message: 'Änderungen gespeichert',
                                icon: 'FAX',
                            });
                            this.faxNumberOld.id = this.pickedPhonenumber.id;
                        })
                        .catch(error => {
                            this.$toasted.global.starface_error({
                                message: 'Fax konnte nicht geändert werden',
                                icon: 'FAX',
                            });
                        });
                    })
                    .catch(error => {
                        this.$toasted.global.starface_error({
                            message: 'Fax konnte nicht geändert werden',
                            icon: 'FAX',
                        });
                    });
                }
                this.updatedFaxConfigForOtherUsers = false;
            },
            setFax() {
                this.isSubmitted = true;
                if (!this.$v.data.$invalid) {
                    if (this.faxExisting) {
                        this.isModalForUpdateVisible = true;
                        this.confirmationButtonText = 'Speichern';
                    } else {
                        if (!this.isTest) {
                            this.isModalForIbanCheckVisible = true;
                        } else {
                            this.manageFaxStatus();
                        }
                    }
                } else {
                    this.$toasted.global.starface_error({
                        message: 'Bitte gebe eine korrekte E-Mail-Adresse an!',
                        icon: 'FAX',
                    });
                }
            },
            deactivateFax(event) {
                if (!event.target.checked) {
                    if (this.faxExisting) {
                        event.preventDefault();
                        this.isModalForDeleteVisible = true;
                    } else {
                        this.faxActivated = !this.faxActivated;
                    }
                } else {
                    this.faxActivated = !this.faxActivated;
                }
            },
            updateFaxHeaderIdAndFaxCallerIdForAllOtherUsers() {
                for (const user of this.allUsers) {
                    const userData = Object.assign({}, user);
                    if (userData.firstName !== 'Fax' && userData.familyName !== 'FaxUser') {
                        userData.faxCallerId = this.data.faxCallerId;
                        userData.faxHeader = this.data.faxHeader;
                        UserService.updateUser(userData.id, userData);
                    }
                }
            },
            closeModalForIbanCheck() {
                this.isModalForIbanCheckVisible = false;
            },
            confirmModalForIbanCheck() {
                    if (!this.isIbanSet) {
                        this.saveIban();
                    }
                    if (this.isIbanSet) {
                        this.isModalForIbanCheckVisible = false;
                        this.manageFaxStatus();
                    }
            },
            saveIban() {
                this.isSubmittedPopup = true;
                if (!this.$v.iban.$invalid) {
                    this.accountInfo.iban = this.iban;

                    AccountService.updateAccount(this.accountInfo).then(responseAccount => {
                        if (responseAccount.data.success != null) {
                            this.isModalForIbanCheckVisible = false;
                            this.getAccount();
                            this.manageFaxStatus();
                        } else {
                            this.$toasted.global.starface_error({
                                message: 'IBAN konnte nicht gespeichert werden. Bitte überprüfe Deine IBAN.',
                                icon: 'FAX',
                            });
                        }
                    })
                    .catch(error => {
                        this.$toasted.global.starface_error({
                            message: 'IBAN konnte nicht gespeichert werden.',
                            icon: 'FAX',
                        });
                    });
                }

            },
        },
    };
</script>

<template>
    <div class="container">
        <div id="user-edit">
            <NavigationHeader route="/" navigationText="zurück zum Dashboard" title="Fax konfigurieren"/>
            <div class="wrapper">
                <div class="form-group form-check">
                    <input class="form-check-input" type="checkbox" id="fax-activated" :checked="faxActivated"
                           @click="deactivateFax($event)">
                    <label class="form-check-label" for="fax-activated">
                        {{faxActivated ? (faxExisting ? 'Fax aktivieren' : 'Fax aktivieren') : 'Fax aktivieren'}}
                    </label>
                </div>
                <div v-if="faxActivated">
                    <div class="fax-number-title">Faxnummer wählen:</div>
                    <form class="form">
                        <div class="phone-numbers">
                            <div class="title">Wähle aus Deiner Rufnummerübersicht:</div>
                            <NumberPicker v-if="pickedPhonenumber" :numbers="allExternalPhonenumbers"
                                          :max-height="'200px'" :columns="4" :defaultValue="pickedPhonenumber"
                                          v-model="pickedPhonenumber"/>
                        </div>
                        <div class="fax-info">
                            <div class="form-group form-text name">
                                <label for="name">Name Faxabsenderkennung::</label>
                                <input class="form-control" type="text" name="name" id="name" v-model="data.faxHeader"
                                       required readonly/>
                            </div>
                            <div class="form-group form-text number">
                                <label for="number">Nummer Faxabsenderkennung::</label>
                                <input v-if="pickedPhonenumber" class="form-control" type="text" name="number"
                                       id="number" v-model="pickedPhonenumber.phonenumber" required readonly/>
                            </div>
                            <div class="description-email">
                                An welche E-Mail-Adresse sollen ankommende Faxe gesendet werden? <a style="color:#F59B00;text-decoration: underline;" href="https://knowledge.starface.de/display/starup/Fax" target="_blank">Mehr Info</a>
                            </div>
                            <div class="form-group form-text email">
                                <label for="email">E-Mail-Adresse für eingehende Faxe:</label>
                                <input class="form-control" type="text" name="email" id="email" v-model="data.email"
                                       v-bind:class="{ 'has-error': isSubmitted && $v.data.email.$invalid }"
                                       @input="$v.data.email.$touch()" required/>
                                <span class="error" v-if="isSubmitted && $v.data.email.$invalid">Bitte gebe eine korrekte E-Mail-Adresse ein!</span>
                            </div>
                        </div>
                    </form>
                    <div class="footer">
                        <ButtonNormal @onClick="$router.push('/')" class="btn-cancel" buttonTitle="Abbrechen"
                                      cssClass="btn btn-secondary"/>
                        <ButtonNormal @onClick="setFax" class="btn-save" :buttonTitle="saveButtonTitle"
                                      cssClass="btn btn-primary" :disabled="!faxDataChanged"/>
                    </div>
                </div>
            </div>
        </div>
        <Modal v-show="isModalForUpdateVisible" :confirmation-button-text="confirmationButtonText"
               @close="closeModalForUpdate" @confirm="manageFaxStatus">
            <template slot="header">
                Möchtest Du die Änderungen wirklich speichern?
            </template>
        </Modal>
        <Modal v-show="isModalForDeleteVisible" :confirmation-button-text="'Fax deaktivieren'"
               @close="closeModalForDelete"
               @confirm="confirmModalForDelete">
            <template slot="header">
                Möchtest Du das Fax wirklich löschen?
            </template>
            <template slot="body">
                Alle Einstellungen gehen dann verloren.
            </template>
        </Modal>
        <Modal v-show="isModalForIbanCheckVisible" confirmationButtonText="Kostenpflichtig hinzufügen" @close="closeModalForIbanCheck" @confirm="confirmModalForIbanCheck">
            <template slot="header">
                Möchtest du Dein Fax für 4,90 € zzgl. MwSt. pro Monat hinzufügen?
            </template>
            <template slot="body">
                <div class="iban-modal">
                    <form  v-if="!isIbanSet" class="form">
                        <p>Für das Hinzufügen Deines Fax benötigen wir Deine Bankverbindung.<br> Bitte trage hier Deine IBAN ein:</p>
                        <div class="form-group form-text iban">
                            <label for="iban">IBAN:</label>
                            <input class="form-control" type="text" name="iban" id="iban"
                                   v-bind:class="{ 'has-error': isSubmittedPopup && $v.iban.$invalid }"
                                   v-model="iban" required/>
                            <span class="error-message" v-if="isSubmittedPopup && $v.iban.$invalid">Bitte gebe Deine IBAN ein.</span>
                        </div>
                    </form>
                </div>
             </template>
        </Modal>
    </div>
</template>

<style lang="scss" scoped>
    @import '../../assets/scss/variables.scss';
    @import '../../assets/scss/general.scss';
    @import '../../assets/scss/inputs.scss';
    @import '../../assets/scss/forms.scss';
    @import '../../assets/scss/grid.scss';

    #user-edit {
        .wrapper {
            .fax-number-title {
                font-size: 28px;
                padding-top: 20px;
                padding-bottom: 16px;
            }

            form {
                .phone-numbers {
                    display: grid;
                    display: -ms-grid;
                    grid-template-columns: 1fr;
                    -ms-grid-columns: 1fr;
                    margin-right: auto;
                    margin-left: auto;
                    margin-bottom: 50px;

                    .title {
                        grid-row: 1;
                        -ms-grid-row: 1;
                        font-weight: bold;
                        margin-bottom: 12px;
                    }

                    .number-pick {
                        grid-row: 2;
                        -ms-grid-row: 2;
                    }

                    .has-error {
                        border-color: #f54d00;
                    }
                }

                .fax-info {
                    display: grid;
                    display: -ms-grid;
                    grid-template-columns: 1fr 1fr;
                    -ms-grid-columns: 1fr 1fr;

                    .name {
                        @extend .grid-column-1;
                        @extend .grid-row-1;
                    }

                    .number {
                        @extend .grid-column-2;
                        @extend .grid-row-1;
                    }

                    .description-email {
                        @extend .grid-row-2;
                        grid-column: 1 / span 2;
                        -ms-grid-column: 1;
                        -ms-grid-column-span: 2;
                        padding-bottom: 16px;
                    }

                    .email {
                        @extend .grid-column-1;
                        @extend .grid-row-3;
                    }
                }
            }


            .footer {
                display: flex;
                justify-content: flex-end;
                flex-wrap: wrap;
                width: 100%;

                .btn-cancel {
                    margin-bottom: 25px;
                }

                .btn-save {
                    margin-left: 25px;
                }
            }
        }
    }
    .error-message {
        font-size: 12px;
        font-weight: 600;
        text-align: left;
        color: $red;
    }
    .has-error {
        border-color: #f54d00;
    }
</style>
